// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700;900&family=Open+Sans:wght@300;400;600;700;800&display=swap);"]);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  font-family: \"Open Sans\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  margin: 0;\n  font-family: \"Barlow\", sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
